__turbopack_context__.v({
  "checkmark": "CountrySelector-module__3OV3_W__checkmark",
  "clearIcon": "CountrySelector-module__3OV3_W__clearIcon",
  "clearSearch": "CountrySelector-module__3OV3_W__clearSearch",
  "closeButton": "CountrySelector-module__3OV3_W__closeButton",
  "countryButton": "CountrySelector-module__3OV3_W__countryButton",
  "countryCode": "CountrySelector-module__3OV3_W__countryCode",
  "countryInfo": "CountrySelector-module__3OV3_W__countryInfo",
  "countryLabel": "CountrySelector-module__3OV3_W__countryLabel",
  "countryList": "CountrySelector-module__3OV3_W__countryList",
  "countryName": "CountrySelector-module__3OV3_W__countryName",
  "countryOption": "CountrySelector-module__3OV3_W__countryOption",
  "countryWrapper": "CountrySelector-module__3OV3_W__countryWrapper",
  "disabled": "CountrySelector-module__3OV3_W__disabled",
  "emptyText": "CountrySelector-module__3OV3_W__emptyText",
  "expandIcon": "CountrySelector-module__3OV3_W__expandIcon",
  "fadeIn": "CountrySelector-module__3OV3_W__fadeIn",
  "full": "CountrySelector-module__3OV3_W__full",
  "giftcardIcon": "CountrySelector-module__3OV3_W__giftcardIcon",
  "globeEmoji": "CountrySelector-module__3OV3_W__globeEmoji",
  "loadingText": "CountrySelector-module__3OV3_W__loadingText",
  "modal": "CountrySelector-module__3OV3_W__modal",
  "modalHeader": "CountrySelector-module__3OV3_W__modalHeader",
  "modalTitle": "CountrySelector-module__3OV3_W__modalTitle",
  "overlay": "CountrySelector-module__3OV3_W__overlay",
  "searchIcon": "CountrySelector-module__3OV3_W__searchIcon",
  "searchInput": "CountrySelector-module__3OV3_W__searchInput",
  "searchWrapper": "CountrySelector-module__3OV3_W__searchWrapper",
  "selected": "CountrySelector-module__3OV3_W__selected",
  "selectedName": "CountrySelector-module__3OV3_W__selectedName",
  "slideUp": "CountrySelector-module__3OV3_W__slideUp",
  "slideUpMobile": "CountrySelector-module__3OV3_W__slideUpMobile",
});
